import idb from "@/plugins/indexdb.js";
import MinervaRepo from "@/repositories/products/minervaRepository.js";

import minervaDefaultForm from "./forms/minerva";

export default {
  namespaced: true,

  state: {
    minerva: minervaDefaultForm
  },

  mutations: {
    SET_MINERVA(state, payload) {
      state.minerva = Object.assign({}, state.minerva, payload); // Merge
    },

    // Clean minerva object
    RESET_MINERVA(state) {
      state.minerva = minervaDefaultForm;
    }
  },
  actions: {
    /**
     * Get minerva product by uuid
     *
     * @param {String} minerva_uuid Minerva uuid
     */
    async get({ commit }, minerva_uuid) {
      try {
        const { data } = await MinervaRepo.get(minerva_uuid);
        commit("SET_MINERVA", data);
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Create a new minerva
    async createMinerva(context, payload) {
      const { data } = await MinervaRepo.createMinerva(payload);
      return data;
    },

    /**
     * Local part
     */

    /**
     * Get minerva product from IndexedDB
     *
     * @param {String} minerva_uuid Minerva uuid
     */
    async getFromLocal({ commit }, minerva_uuid) {
      const minerva = await idb.db.minerva.get(minerva_uuid);

      // If not found return null
      if (!minerva) return null;

      commit("SET_MINERVA", minerva);

      return minerva;
    },

    resetProduct({ commit }) {
      commit("RESET_MINERVA");
    }
  }
};
